import axios, { type AxiosResponse } from 'axios';

import type {
  CleanKindFetchResponse,
  SubscriptionPlanData,
  TicketsForCleanKind,
} from '../sharedTypes';

export const getSubscriptionPlanList = async (url: string) => {
  const res: AxiosResponse<SubscriptionPlanData[]> = await axios({
    method: 'GET',
    url,
    headers: {
      authorization: localStorage.getItem('feathers-jwt'),
    },
  });
  return res.data;
};

export const getTicketInfo = async (url: string) => {
  const res: AxiosResponse<TicketsForCleanKind[]> = await axios({
    method: 'GET',
    url,
    headers: {
      authorization: localStorage.getItem('feathers-jwt'),
    },
  });
  return res.data;
};

export const getCleanKindData = async (
  url: string,
  cleanKindId: string | undefined
) => {
  const res: AxiosResponse<CleanKindFetchResponse> = await axios({
    method: 'GET',
    url,
    headers: {
      authorization: localStorage.getItem('feathers-jwt'),
    },
    params: {
      cleanKindId,
    },
  });
  return res.data;
};
